"use client";

import * as React from "react";

import { cn } from "./utils";

function Label({
  className,
  ...props
}: React.LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    <label
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-sm font-medium text-gray-700",
        className,
      )}
      {...props}
    />
  );
}

export { Label };
